<template>
    <div class="snow-group">
        <img
            v-for="(flake, index) in snowflakes"
            :key="index"
            :src="flake.img"
            class="snow"
            :style="{
            left: flake.left,
            width: flake.size,
            animationDuration: flake.duration,
            animationDelay: flake.delay,
            opacity: flake.opacity || '0.3'
            }"
        />
        </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 15
    }
  },
  data () {
    return {
      snowflakes: [],
      snowflakeImages: [
        '/static/img/acCleaning/ac-v2/snow-ice-1.svg',
        '/static/img/acCleaning/ac-v2/snow-ice-2.svg'
      ]
    }
  },
  mounted () {
    const minSize = 30
    const maxSize = 100
    const maxLargeSnow1 = 2
    let largeSnow1Count = 0

    this.snowflakes = []

    while (this.snowflakes.length < this.amount) {
      const selectedImage = this.snowflakeImages[Math.floor(Math.random() * this.snowflakeImages.length)]

      let sizeNum
      if (selectedImage.includes('snow-ice-2')) {
        sizeNum = Math.floor(Math.random() * 11) + 10 // 10–20
      } else {
        sizeNum = Math.floor(Math.random() * (maxSize - minSize)) + minSize // 30–100
      }
      // match size for checking large snowflake
      let matchSizeMax = 60
      if (selectedImage.includes('snow-ice-1') && sizeNum > matchSizeMax) {
        if (largeSnow1Count >= maxLargeSnow1) continue
        largeSnow1Count++
      }

      this.snowflakes.push({
        img: selectedImage,
        left: `${Math.random() * 100}%`,
        size: `${sizeNum}px`,
        duration: `${Math.random() * 5 + 10}s`, // 5–15s
        delay: `${Math.random() * 3}s`, // 0–3s
        opacity: `${Math.random() * 0.3 + 0.3}` // 0.3–0.6
      })
    }
  }

}
</script>

<style scoped lang="scss">
.snow-group {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;

  .snow {
    position: absolute;
    top: -30px;
    animation-name: snowfall;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    opacity: 0.3;
  }
}

@keyframes snowfall {
  0% {
    transform: translateY(0) translateX(0);
  }
  100% {
    transform: translateY(110vh) translateX(30px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/materials/SnowFlake.vue